import { ArrowRightOutlined } from "@ant-design/icons";
import { Empty, Table } from "antd";
import { Link } from "react-router-dom";
import { Calificacion } from "../../shared/Calificacion";
import { fechaVisible } from "../../shared/evaluacionesUtils";
import styles from "../../shared/Evaluaciones.module.css";

export function TablaEvaluaciones({ filas, cargando, origen }) {
  const columns = [
    {
      title: "Servicio",
      dataIndex: "asistenciaID",
      render: value => <strong className={styles.mono}>{value}</strong>,
    },
    {
      title: "Operador",
      dataIndex: "usuarioNombre",
      render: value => <strong>{value}</strong>,
    },
    {
      title: "Calificación",
      dataIndex: "calificacion",
      render: value => <Calificacion value={value} />,
    },
    {
      title: "Fecha de evaluación",
      dataIndex: "fechaEvaluacion",
      render: fechaVisible,
    },
    {
      title: "",
      key: "accion",
      render: (_, item) => (
        <Link
          to={{
            pathname: `/evaluaciones/${item.id}`,
            state: { origen, registro: item },
          }}
        >
          Ver evaluación <ArrowRightOutlined />
        </Link>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={filas}
      loading={cargando}
      scroll={{ x: 800 }}
      pagination={{ pageSize: 8, hideOnSinglePage: true }}
      locale={{ emptyText: <Empty description="No se encontraron coincidencias" /> }}
    />
  );
}
